import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSelectedTabListPickupView, getUserData, setSelectedTabListPickupView } from "../../utils/localStorage";
import SuccessModal from "../SuccessModal";
import JobRequests from "./JobRequests";
import TabMenu from "../TabMenu";
import { postStoreRiderJobPickupOrDelivery } from "../../services/StoreRiderInfo/StoreRiderInfo";
import StatusFilterModal from "../StatusFilterModal";
import StoreMenu from "../StoreMenu";
import ButtonLink from "../../ButtonLink";
import { formatDateNewWithTime, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { formatDate } from "../../constants/FormateDate";
import JobRequestsListView from "./JobRequestsListView";
import { ProgressSpinner } from "primereact/progressspinner";

const { innerWidth: width, innerHeight: height } = window;

const DashboardDeliveryJob = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderFilterData, source } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const { storeData } = getUserData();

  const storeId = storeData.id;
  const jobType = "delivery";

  const [tabularView, setTabularView] = useState(false);

  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [focusedField, setFocusedField] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState("ALL");

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth() - 120);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [orderInfoData, setOrderInfoData] = useState([]);
  const [todayOrderData, setTodayOrderData] = useState([]);


  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListPickupView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListPickupView();
      setTabularView(selectedInvoiceTypeData?.tabListPickupView || "list");
    } catch {
      setTabularView("list");
    }
  };


  const fetchRiderJobDeliveryData = (data) => {
    setIsLoading(true);
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then((response) => {
        if (!response.data.error) {
          setIsLoading(false);
          const Res = response.data;
          setTodayOrderData(Res);
        }
      })
      .catch((err) => {
        console.error("Rider Job Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
      endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
      jobStatus: orderFilterData.statusIn,
    };
    fetchRiderJobDeliveryData(data);
    fetchSelectedTabListView();
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
      endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
      jobStatus: orderFilterData.statusIn,
    };
    fetchRiderJobDeliveryData(data);
    fetchSelectedTabListView();
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    // setSelectedStatus(selectedStatus);
    handleConfirmDelivery(selectedStatus);
  };

  const handleConfirmDelivery = (selectedStatus) => {
    // Create a new delivery request object
   
    if (!isGetJobButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGetJobButtonPressed(true);
      setTimeout(() => {
        

        const data = {
          startDate: localeDateStartDate(new Date(new Date(orderFilterData.startDate))),
          endDate: localeDateEndDate(new Date(new Date(orderFilterData.endDate))),
          jobStatus:
            selectedStatus !== "ALL"
              ? selectedStatus
              : orderFilterData.statusIn,
        };
        fetchRiderJobDeliveryData(data);

        setIsGetJobButtonPressed(false);
        // Reset the form fields
      }, 1000); // Replace with actual async operation duration
    }
  };


  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const exportData = todayOrderData.map((item) => ({
        "Invoice No.": item.deliveryRequest.order.invoiceNo,
        "Created At": formatDateNewWithTime(item?.createdDate),
        "Rider Name": item?.deliveryRequest?.rider.firstName + " " + item?.deliveryRequest?.rider.lastName,
        "Customer Name": item?.deliveryRequest?.order?.customerName,
        "Customer Mobile": item?.deliveryRequest?.order?.customerMobile,
        "Customer Address": item?.deliveryRequest?.order?.customerAddress,
        "Reschedule Date": formatDate(item?.deliveryRequest?.deliveryOn),
        "Time Slot": item?.deliveryRequest.deliveryTimeSlot,
        "Status": item?.deliveryRequest.deliveryStatus.replace(/_/g, " "),
        "remarks": item?.deliveryRequest?.remarks,
      }));

      // 👉 Calculate totals
      // const totals = exportData.reduce(
      //   (acc, row) => {
      //     acc.Pcs += row.Pcs;
      //     acc.Amount += row.Amount;
      //     acc.Balance += row.Balance;
      //     return acc;
      //   },
      //   { Pcs: 0, Amount: 0, Balance: 0 }
      // );

      // 👉 Add total row
      // exportData.push({
      //   "Invoice No": "TOTAL",
      //   "Booking Date": "",
      //   "Due Date": "",
      //   "Customer Name": "",
      //   Mobile: "",
      //   Status: "",
      //   Pcs: totals.Pcs,
      //   Amount: totals.Amount,
      //   Balance: totals.Balance,
      //   UD: "",
      //   HD: "",
      //   "Order Source": "",
      //   Remarks: "",
      //   "Delivery Remarks": "",
      // });

      const worksheet = xlsx.utils.json_to_sheet(exportData);

      const workbook = {
        Sheets: { data: worksheet },
        SheetNames: ["data"],
      };

      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Delivery_Job_List");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Delivery Job
              </p>
            </div>
          </div>

          <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={exportExcel}
                src={"images/file.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#22C55E",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={"Added"}
        text={"Your Amount is added successfully."}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          "DELIVERY_REQ",
          "ASSIGNED_TO_RIDER",
          "RESCHEDULE_BY_CUSTOMER",
          "RESCHEDULE_BY_RIDER",
          "OUT_FOR_DELIVERY",
        ]}
      />

      <div>
        {tabularView === "tab" && (
          <div
            className="scroll-bar mb-2"
            style={{
              height: height - 80,
              overflowY: "scroll",
            }}
          >
            {isLoading ? (
              <div style={{ flex: 1 }}>
                <div className="text-center">
                  <ProgressSpinner
                    style={{ width: "70px", height: "70px" }}
                    strokeWidth="4"
                    fill="var(--surface-ground)"
                    animationDuration="2s"
                  />
                </div>
              </div>) : (

              <JobRequestsListView
                orderInfoData={todayOrderData}
                JobType={jobType}
                storeId={storeId}
                callRequestApi={callRequestApi}
              // pickupType={orderBookedType}
              />
            )}
          </div>
        )}
      </div>

      <div style={{ display: tabularView === "tab" ? "none" : "" }}>
        {isLoading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>) : (
          <JobRequests
            orderInfoData={todayOrderData}
            JobType={jobType}
            storeId={storeId}
            callRequestApi={callRequestApi}
          />
        )}
      </div>

      {/* <TabMenu /> */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default DashboardDeliveryJob;
